<template>
  <div class="goto-register eee">
    <p class="label">{{ label }}</p>
    <div class="regis-ways">
      <div class="way">
        <el-button
          type="primary"
          class="way"
          @click="gotoRigisterDetail('enterprise')"
          >企业账号注册</el-button
        >
        <!--<p class="description">供应链票据融资、债权资产、物权资产等</p>-->
      </div>
      <!-- 新版首页不区分账户类型 -->
      <div class="way" v-if="false">
        <el-button
          type="primary"
          class="way"
          @click="gotoRigisterDetail('person')"
          >个人账号注册</el-button
        >
        <p class="description">债权资产、物权资产</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String
    }
  },
  methods: {
    gotoRigisterDetail(type = "enterprise") {
      const name =
        type === "enterprise" ? "registerEnterprise" : "registerPerson";
      this.$router.push({ name });
    }
  }
};
</script>

<style lang="scss">
.goto-register {
  margin-top: 20px;

  .label {
    padding: 10px 0;
    border-bottom: solid 1px $high;
    font-size: 14px;
    opacity: 0.6;
  }

  .regis-ways {
    display: flex;
    justify-content: space-between;
    margin-top: 40px;
  }

  .way {
    margin-right: 20px;
    width: 100%;
    background: transparent;
    color: #666;

    &:hover {
      box-shadow: 0 0 6px rgba(0, 0, 0, 0.1);
    }

    button {
      width: 100%;
      border-radius: 5px;
      border: solid 1px #ddd;
    }

    .description {
      margin-top: 6px;
      font-size: 13px;
      text-align: center;
      color: #888;
    }

    &:nth-of-type(1) {
      button {
        border: 0;
        background: $high;
        color: #fff;
        opacity: 0.8;
      }
    }
  }

  .text {
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #666;
    font-size: 14px;
    font-weight: lighter;
  }
}
</style>
